import { render, staticRenderFns } from "./BusinessShares.vue?vue&type=template&id=682d6d9a"
import script from "./BusinessShares.vue?vue&type=script&lang=js"
export * from "./BusinessShares.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports